import React, { useState } from 'react';

const VyjednameLogo = ({ className = "", width = 300, height = 80, variant = "horizontal", logoUrl = null, tenantName = null }) => {
  const [imgError, setImgError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [tenantLogoError, setTenantLogoError] = useState(false);

  // Pokud má tenant vlastní logo, použij ho (s fallbackem na výchozí logo při chybě)
  if (logoUrl && !tenantLogoError) {
    const displayName = tenantName || 'VYJEDNÁME';
    if (variant === "vertical") {
      return (
        <div className={`flex flex-col items-center ${className}`} style={{ width, height: 'auto' }}>
          <img
            src={logoUrl}
            alt={`${displayName} Logo`}
            style={{ height: height * 0.6, width: 'auto', objectFit: 'contain', maxWidth: width }}
            className="dark:brightness-90 mb-2"
            onError={() => setTenantLogoError(true)}
          />
          <h1 className="text-lg font-bold text-gray-800 dark:text-white tracking-wide">
            {displayName.toUpperCase()}
          </h1>
        </div>
      );
    }
    return (
      <div className={`flex flex-row items-center ${className}`} style={{ width, height }}>
        <img
          src={logoUrl}
          alt={`${displayName} Logo`}
          style={{ height, width: 'auto', objectFit: 'contain', maxWidth: width * 0.7 }}
          className="dark:brightness-90 mr-2 sm:mr-3"
          onError={() => setTenantLogoError(true)}
        />
        <h1 className="text-lg sm:text-2xl font-bold text-gray-800 dark:text-white tracking-wide">
          {displayName.toUpperCase()}
        </h1>
      </div>
    );
  }

  // Výchozí logo Vyjednáme
  const getLogoSrc = () => {
    if (retryCount === 0) return "/vyjedname-logo.png";
    return `/vyjedname-logo.png?v=${Date.now()}`;
  };

  const handleImageError = () => {
    console.warn('⚠️ Logo loading failed, retry:', retryCount);
    if (retryCount < 3) {
      setTimeout(() => { setRetryCount(prev => prev + 1); setImgError(false); }, 1000);
    } else {
      setImgError(true);
    }
  };

  const handleImageLoad = () => { setImgError(false); setRetryCount(0); };

  if (variant === "vertical") {
    return (
      <div className={`flex flex-col items-center ${className}`} style={{ width, height: 'auto' }}>
        {!imgError ? (
          <img src={getLogoSrc()} alt="Vyjednáme Logo" style={{ height: height * 0.6, width: 'auto', objectFit: 'contain' }}
            className="dark:brightness-90 mb-2" onError={handleImageError} onLoad={handleImageLoad} loading="eager" decoding="async" />
        ) : (
          <div className="bg-blue-600 dark:bg-blue-500 rounded-lg mb-2 flex items-center justify-center"
            style={{ height: height * 0.6, width: height * 0.6 }}>
            <span className="text-white font-bold text-2xl">V</span>
          </div>
        )}
        <h1 className="text-lg font-bold text-gray-800 dark:text-white tracking-wide">VYJEDNÁME</h1>
      </div>
    );
  }

  return (
    <div className={`flex flex-row items-center ${className}`} style={{ width, height }}>
      {!imgError ? (
        <img src={getLogoSrc()} alt="Vyjednáme Logo" style={{ height, width: 'auto', objectFit: 'contain' }}
          className="dark:brightness-90 mr-2 sm:mr-3" onError={handleImageError} onLoad={handleImageLoad} loading="eager" decoding="async" />
      ) : (
        <div className="bg-blue-600 dark:bg-blue-500 rounded-lg mr-2 sm:mr-3 flex items-center justify-center flex-shrink-0"
          style={{ height, width: height }}>
          <span className="text-white font-bold" style={{ fontSize: height * 0.5 }}>V</span>
        </div>
      )}
      <h1 className="text-lg sm:text-2xl font-bold text-gray-800 dark:text-white tracking-wide">VYJEDNÁME</h1>
    </div>
  );
};

export default VyjednameLogo;
